import React from "react";
import { LuCircleUserRound } from "react-icons/lu";
import { PiTranslateBold } from "react-icons/pi";
import "../styles/Header.scss";
import { useLanguage } from "../context/LanguageContext";

const Header = ({ theme = "day" }) => {
  const themeClass = theme === "night" ? "header--night" : "";
  const logoSrc =
    theme === "night" ? "/assets/wayli_logo_light.png" : "/assets/wayli_logo.png";
  const { language, toggleLanguage, t } = useLanguage();
  const languageLabel = t(`header.languageLabel.${language}`, language.toUpperCase());

  return (
    <header className={`header ${themeClass}`.trim()}>
      <div className="logo">
        <a href="/">
          <img src={logoSrc} alt={t("header.logoAlt", "Wayli logo")} />
        </a>
      </div>

      <nav>
        <ul>
          <li><a href="/#price">{t("header.nav.price", "PRICE")}</a></li>
          <li><a href="booking">{t("header.nav.booking", "BOOKING")}</a></li>
          <li><a href="info">{t("header.nav.info", "INFO")}</a></li>
        </ul>
      </nav>

      <div className="header-icons">
        <button
          type="button"
          className="language-toggle"
          onClick={toggleLanguage}
          aria-label={
            language === "en"
              ? t("header.actions.switchToGerman", "Switch to German")
              : t("header.actions.switchToEnglish", "Switch to English")
          }
        >
          <PiTranslateBold aria-hidden="true" />
          <span>{languageLabel}</span>
        </button>
        <LuCircleUserRound
          className="profile-icon"
          onClick={() => (window.location.href = "profile")}
        />
      </div>
    </header>
  );
};

export default Header;
